import {all, call, put, takeLatest} from 'redux-saga/effects';
import * as constants from '../constants';
import * as api from '../services/api';
import {logout} from '../actions/action_auth';
import * as actions from '../actions/action_admin_organization';

function* fetchList({payload}) {
    try {
        const response = yield call(api.adminFetchOrganizationList);
        yield put(actions.adminOrganizationListSuccess(response.data));
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(logout());
        }
        yield put(actions.adminOrganizationListFailure(error));
    }
}
export default function* root() {
    yield all([
        takeLatest(constants.ADMIN_ORGANIZATION_LIST_REQUESTED, fetchList),
    ]);
}
